// Punto de integración con el backend para FASES FUTURAS.
// Hoy está deshabilitado (enabled=false) y el juego funciona 100% offline con PlayerData.
// Cuando exista backend, activar y estas funciones enviarán/recibirán datos reales:
//   - cuentas de estudiantes / perfiles / avatares
//   - progreso en la nube
//   - rankings globales / por colegio / por clase
//   - retos entre jugadores y multijugador (asíncrono o en tiempo real)
//
// La puntuación incluye una firma verificable (ver ScoreSystem) para rankings justos.

import { API_BASE } from '../config';

export class ApiClient {
  constructor(baseURL = API_BASE) {
    this.baseURL = `${baseURL}/api`;
    this.enabled = false; // Activar cuando el backend esté disponible.
    this.token = null;
  }

  setToken(token) {
    this.token = token;
  }

  async submitScore(run) {
    if (!this.enabled) return { queued: true, local: true, run };
    // Futuro: return fetch(`${this.baseURL}/scores`, { method:'POST', ... })
    return { ok: true };
  }

  async getLeaderboard() {
    if (!this.enabled) return [];
    // Futuro: return fetch(`${this.baseURL}/leaderboard`).then(r => r.json());
    return [];
  }

  async syncProgress() {
    if (!this.enabled) return { synced: false };
    return { synced: true };
  }
}

export const apiClient = new ApiClient();
